import { Component, OnInit, ViewChild } from '@angular/core';
import { iBisViewComponent } from '@dohu/ibis-common';
import { ProxyService } from '../../../service/proxy.service';
import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';
import * as XLSX from 'xlsx';
import { HttpClient } from '@angular/common/http';

@Component({
    templateUrl: 'location.component.html',
    styleUrls: ['location.component.scss'],

})
export class LocationComponent extends iBisViewComponent implements OnInit {
    @ViewChild('locationGrid') declare grid: DxDataGridComponent;

    locations = []

    constructor(public proxy: ProxyService, private http: HttpClient) {
        super(null, proxy.lg, proxy.iui, proxy.activatedRoute);
        this.key = '[MDS]GraphicArea';
    }

    ngOnInit(): void {
        this.http.get('assets/locatii_automate.xlsx', { responseType: 'arraybuffer' }).subscribe((res: ArrayBuffer) => {
            const data = new Uint8Array(res);
            const workbook = XLSX.read(data, { type: 'array' });

            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const json = XLSX.utils.sheet_to_json(sheet);
            json.forEach((row: any) => {
                const location = {
                    address: row['Adresa'],
                    //lat: row['Geo Y'],
                    // lng: row['Geo X'],

                    // reversed X and Y because of the way the data is structured
                    lat: row['Geo X'],
                    lng: row['Geo Y'],
                    town: row['Oras'],
                };
                this.locations.push(location);
            });
            console.log(this.locations); // 2D array of rows
        });
    }

}
